export function formatKr(amount, currency = "NOK") {
  if (amount === null || amount === undefined || Number.isNaN(Number(amount))) return "–";
  const n = Number(amount);
  const parts = n.toFixed(2).split(".");
  const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  const s = `${intPart},${parts[1]}`;
  return currency && currency !== "NOK" ? `${s} ${currency}` : `${s} kr`;
}

export function formatDate(iso) {
  if (!iso) return "–";
  const s = String(iso).slice(0, 10);
  const [y, m, d] = s.split("-");
  if (!y || !m || !d) return iso;
  return `${d}.${m}.${y}`;
}

export function formatDateTime(iso) {
  if (!iso) return "–";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    const pad = (x) => String(x).padStart(2, "0");
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  } catch {
    return iso;
  }
}

export function formatAccount(acc) {
  if (!acc) return "–";
  const digits = String(acc).replace(/\D/g, "");
  if (digits.length === 11) return `${digits.slice(0, 4)}.${digits.slice(4, 6)}.${digits.slice(6)}`;
  return acc;
}

export function formatOrg(org) {
  if (!org) return "–";
  const d = String(org).replace(/\D/g, "");
  if (d.length === 9) return `${d.slice(0, 3)} ${d.slice(3, 6)} ${d.slice(6)}`;
  return org;
}

export function formatBytes(bytes) {
  if (!bytes) return "0 B";
  const units = ["B", "KB", "MB", "GB"];
  let i = 0;
  let n = bytes;
  while (n >= 1024 && i < units.length - 1) {
    n /= 1024;
    i += 1;
  }
  return `${n.toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
}

const MONTHS = ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"];
const MONTHS_SHORT = ["jan", "feb", "mar", "apr", "mai", "jun", "jul", "aug", "sep", "okt", "nov", "des"];

export function formatMonth(ym, short = false) {
  if (!ym) return "";
  const [y, m] = ym.split("-");
  const idx = Number(m) - 1;
  const name = short ? MONTHS_SHORT[idx] : MONTHS[idx];
  return short ? `${name} ${String(y).slice(2)}` : `${name.charAt(0).toUpperCase()}${name.slice(1)} ${y}`;
}

export function daysLabel(days) {
  if (days === null || days === undefined) return "";
  if (days < 0) return `${Math.abs(days)} ${Math.abs(days) === 1 ? "dag" : "dager"} over forfall`;
  if (days === 0) return "Forfaller i dag";
  if (days === 1) return "Forfaller i morgen";
  return `Forfaller om ${days} dager`;
}

export function todayIso() {
  const d = new Date();
  const pad = (x) => String(x).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(String(text));
    return true;
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = String(text);
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
      return true;
    } catch {
      return false;
    }
  }
}
